/**
 * Wishlist toggle buttons (product card, PDP purchase box) talk to the
 * "rewards" Shopify app via its app proxy — same-origin, so the proxy can
 * verify the request and resolve the customer from the signed
 * logged_in_customer_id param itself. The theme never sends a customer id.
 *
 * Initial button state (which products are already on the customer's
 * wishlist) is hydrated on load from the list endpoint below — only run for
 * logged-in customers, since the endpoint 401s otherwise.
 */
(function () {
  if (window.NexWishlist) return;

  var LIST_URL = '/apps/rewards/wishlist';
  var ADD_URL = '/apps/rewards/wishlist/add';
  var REMOVE_URL = '/apps/rewards/wishlist/remove';
  var SELECTOR = '[data-wishlist-button]';

  function isCustomerLoggedIn() {
    return document.documentElement.getAttribute('data-customer-logged-in') === 'true';
  }

  function redirectToLogin() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var returnTo = encodeURIComponent(window.location.pathname + window.location.search);
    window.location.href = root.replace(/\/$/, '') + '/account/login?return_url=' + returnTo;
  }

  function setButtonsState(productId, active) {
    document
      .querySelectorAll(SELECTOR + '[data-product-id="' + productId + '"]')
      .forEach(function (button) {
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
  }

  function postWishlist(url, productId) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ productId: productId }),
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Wishlist request to ' + url + ' failed with status ' + response.status);
      }
      return response;
    });
  }

  function toggleWishlist(button) {
    var productId = button.getAttribute('data-product-id');
    if (!productId) return;

    if (!isCustomerLoggedIn()) {
      redirectToLogin();
      return;
    }

    var wasActive = button.classList.contains('is-active');
    var nextActive = !wasActive;

    setButtonsState(productId, nextActive);
    button.disabled = true;

    postWishlist(nextActive ? ADD_URL : REMOVE_URL, productId)
      .then(function () {
        document.dispatchEvent(
          new CustomEvent('wishlist:updated', {
            detail: { productId: productId, active: nextActive },
          })
        );
      })
      .catch(function (error) {
        setButtonsState(productId, wasActive);
        console.error('[wishlist]', error);
      })
      .finally(function () {
        document
          .querySelectorAll(SELECTOR + '[data-product-id="' + productId + '"]')
          .forEach(function (el) {
            el.disabled = false;
          });
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest(SELECTOR);
    if (!button) return;
    event.preventDefault();
    if (button.disabled) return;
    toggleWishlist(button);
  });

  function hydrateInitialState() {
    if (!isCustomerLoggedIn()) return;
    if (!document.querySelector(SELECTOR)) return;

    fetch(LIST_URL, { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Wishlist list request failed with status ' + response.status);
        }
        return response.json();
      })
      .then(function (data) {
        (data.items || []).forEach(function (item) {
          setButtonsState(item.productId, true);
        });
      })
      .catch(function (error) {
        console.error('[wishlist] failed to hydrate initial state', error);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrateInitialState);
  } else {
    hydrateInitialState();
  }

  window.NexWishlist = {
    toggleWishlist: toggleWishlist,
    setButtonsState: setButtonsState,
    hydrateInitialState: hydrateInitialState,
  };
})();
